import {Component, input} from '@angular/core';
import {environment} from '@env/environment';

@Component({
  selector: 'app-trustpilot',
  templateUrl: './trustpilot.component.html',
  styleUrls: ['./trustpilot.component.scss'],
  standalone: true,
})
export class TrustpilotComponent {

  // Allow overrides via inputs, otherwise use environment defaults
  webpage = input<string>(environment.supervin.frontendHostname);
  businessunitId = input<string>((environment as any).trustpilot?.businessunitId ?? '488898fc00006400050306c7');
  locale = input<string>((environment as any).trustpilot?.locale ?? 'da-DK');
  theme = input<string>('dark');
  styleHeightPx = input<number>(40);
  templateId = input<string>('5419b6ffb0d04a076446a9af');

  get URL(): string {
    // Extract locale prefix (e.g., 'da' from 'da-DK')
    const localePrefix = this.locale().split('-')[0];
    return `https://${localePrefix}.trustpilot.com/review/${this.webpage()}`;
  }

}
